/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Lean_KullanimInputs */

const tr_footer_lean_kullanim = /** @type {(inputs: Footer_Lean_KullanimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanım Koşulları`)
};

const en_footer_lean_kullanim = /** @type {(inputs: Footer_Lean_KullanimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Use`)
};

const de_footer_lean_kullanim = /** @type {(inputs: Footer_Lean_KullanimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen`)
};

const ru_footer_lean_kullanim = /** @type {(inputs: Footer_Lean_KullanimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия использования`)
};

/**
* | output |
* | --- |
* | "Terms of Use" |
*
* @param {Footer_Lean_KullanimInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const footer_lean_kullanim = /** @type {((inputs?: Footer_Lean_KullanimInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Lean_KullanimInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_lean_kullanim(inputs)
	if (locale === "de") return de_footer_lean_kullanim(inputs)
	if (locale === "ru") return ru_footer_lean_kullanim(inputs)
	return tr_footer_lean_kullanim(inputs)
});